import {
  Box,
  List,
  Stack,
  Divider,
  ListItem,
  ListItemButton,
} from "@mui/material";
import Text from "src/components/Displays/Text";
import { SESSION_KEYS } from "src/consts/session";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useSessionStorage } from "src/hooks/useSessionStorage";
import PrimaryButton from "src/components/Shared/PrimaryButton";
import CopyToClipboard from "src/components/Shared/CopyToClipboard";
import { OrchestrationInfo } from "src/models/smartChargingClientsModels";
import EvseListItem from "src/components/SmartCharging/Components/EvseListItem";

const Details = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const uuid = searchParams.get("evse") || "";
  const [getOrchestrationInfo] = useSessionStorage<OrchestrationInfo>(
    SESSION_KEYS.ORCHESTRATION_INFO,
  );
  const installedEvses = getOrchestrationInfo()?.installedEvses ?? [];
  const evseDetails = installedEvses.find((evse) => evse.uuid === uuid);

  const handleinstalledEvseClick = () => {
    return `${navigate("/onboarding-guides/wallboxes/GOE_CHARGER_V1.pdf")}`;
  };

  const handleBackClick = () => {
    navigate(-1);
  };

  return (
    <Stack gap={5}>
      <Text
        text={evseDetails?.serialNumber ?? "n.a."}
        sx={(theme) => ({
          fontWeight: 500,
          fontSize: "32px",
          lineHeight: "40px",
          fontFamily: "officina",
          color: theme.palette.mainFont.primary,
        })}
      />

      <Stack gap={5}>
        <Box
          sx={(theme) => ({
            px: "16px",
            borderRadius: "12px",
            bgcolor: theme.palette.white.main,
          })}
        >
          {evseDetails && (
            <List>
              {evseDetails.manufacturer && (
                <>
                  <EvseListItem
                    showArrowIcon={false}
                    itemText={"Hersteller"}
                    itemTextValue={evseDetails.manufacturer}
                  />
                </>
              )}

              {evseDetails.model && (
                <>
                  <Divider sx={{ ml: "16px", mr: "16px" }} />
                  <EvseListItem
                    showArrowIcon={false}
                    itemText={"Modell"}
                    itemTextValue={evseDetails.model}
                  />
                </>
              )}

              {evseDetails.onboardingGuideUrlPath && (
                <>
                  <Divider sx={{ ml: "16px", mr: "16px" }} />
                  <EvseListItem
                    showArrowIcon={true}
                    itemText={"Anleitung"}
                    handleItemClick={handleinstalledEvseClick}
                  />
                </>
              )}

              {evseDetails.connectionUrl && (
                <>
                  <Divider sx={{ ml: "16px", mr: "16px" }} />
                  <ListItemButton>
                    <Stack
                      sx={{
                        flexDirection: "column",
                        width: "100%",
                        gap: 1,
                        py: 2,
                      }}
                    >
                      <Text
                        text={"OCPP-URL"}
                        sx={(theme) => ({
                          fontSize: "14px",
                          fontWeight: "400",
                          lineHeight: "20px",
                          fontFamily: "Inter",
                          color: theme.palette.black[50],
                        })}
                      />

                      <Stack
                        direction={"row"}
                        alignItems={"center"}
                        justifyContent={"space-between"}
                      >
                        <Text
                          text={evseDetails?.connectionUrl}
                          sx={(theme) => ({
                            fontSize: "12px",
                            fontWeight: "400",
                            lineHeight: "20px",
                            fontFamily: "Inter",
                            color: theme.palette.black[50],
                          })}
                        />

                        <CopyToClipboard
                          id={evseDetails?.connectionUrl}
                          message={`URL ${evseDetails?.connectionUrl} copied to clipboard`}
                        />
                      </Stack>
                    </Stack>
                  </ListItemButton>
                </>
              )}

              <ListItem disablePadding></ListItem>
            </List>
          )}
        </Box>
      </Stack>

      <Box>
        <PrimaryButton onClick={handleBackClick} text={"Zurück"} />
      </Box>
    </Stack>
  );
};

export default Details;
